module.exports = __webpack_public_path__ + "static/media/goal2.35c920e6.svg";